// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__23RYD","Label":"Checkbox_Label__2Bwep","InputElement":"Checkbox_InputElement__2cuVp","Invalid":"Checkbox_Invalid__2lh7h"};